let location_map,
    map_container,
    map_search_field,
    map_autocomplete,
    map_options,
    map_zoom,
    map_zoom_default,
    map_zoom_max,
    map_center_lat,
    map_center_lng,
    map_marker_icon,
    map_marker_active,
    map_markers,
    map_markers_cluster,
    map_infowindow,
    map_distance_units,
    map_locations,
    template_results,
    template_results_count,
    locations_array = {},
    locations_array_full = {},
    search_results_found = null,
    sr_results_count = jQuery('#location-finder-list-view .results #resultsText');

let modals = {},
    current_location = {
        latitude: parseFloat(jQuery('#locationFinder #center_map_lat').val()),
        longitude: parseFloat(jQuery('#locationFinder #center_map_lng').val())
    };

// Hide error msg
jQuery('#locationFinder').on('focus keydown', '#searchField', function () {
    if (jQuery('#locationFinder').find('.error-msg').hasClass('active')) {
        jQuery('#locationFinder').find('.error-msg').removeClass('active');
    }
});

function initMap() {
    locations_array = locations_array_full;
    map_container = document.getElementById('location-finder-map');
    map_search_field = document.getElementById('searchField');
    map_zoom_default = parseFloat(jQuery('#locationFinder #default-zoom').val());
    map_zoom_max = parseFloat(jQuery('#locationFinder #search-zoom').val());
    map_center_lat = parseFloat(jQuery('#locationFinder #center_map_lat').val());
    map_center_lng = parseFloat(jQuery('#locationFinder #center_map_lng').val());

    map_options = {
        center: {
            lat: map_center_lat,
            lng: map_center_lng
        },
        scrollwheel: false,
        zoom: map_zoom_default,
        mapTypeControl: true,
        streetViewControl: false,
        mapTypeControlOptions: {
            position: google.maps.ControlPosition.TOP_RIGHT
        },
        styles: [
            {elementType: 'geometry', stylers: [{color: '#f6f6f4'}]},
            {elementType: 'labels.text.stroke', stylers: [{color: '#f5f5f5'}]},
            {elementType: 'labels.text.fill', stylers: [{color: '#616161'}]},
            {
                featureType: 'administrative.land_parcel',
                elementType: 'labels.text.fill',
                stylers: [{color: '#bdbdbd'}]
            },
            {
                featureType: 'poi',
                elementType: 'geometry',
                stylers: [{color: '#eeeeee'}]
            },
            {
                featureType: 'poi',
                elementType: 'labels.text.fill',
                stylers: [{color: '#757575'}]
            },
            {
                featureType: 'poi.park',
                elementType: 'geometry',
                stylers: [{color: '#e5e5e5'}]
            },
            {
                featureType: 'poi.park',
                elementType: 'geometry.fill',
                stylers: [{color: '#eceeed'}]
            },
            {
                featureType: 'poi.park',
                elementType: 'labels.text.fill',
                stylers: [{color: '#9e9e9e'}]
            },
            {
                featureType: 'road',
                elementType: 'geometry',
                stylers: [{color: '#ffffff'}]
            },
            {
                featureType: 'road.arterial',
                elementType: 'labels.text.fill',
                stylers: [{color: '#757575'}]
            },
            {
                featureType: 'road.highway',
                elementType: 'geometry',
                stylers: [{color: '#dadada'}]
            },
            {
                featureType: 'road.highway',
                elementType: 'labels.text.fill',
                stylers: [{color: '#616161'}]
            },
            {
                featureType: 'road.local',
                elementType: 'labels.text.fill',
                stylers: [{color: '#9e9e9e'}]
            },
            {
                featureType: 'transit.line',
                elementType: 'geometry',
                stylers: [{color: '#e5e5e5'}]
            },
            {
                featureType: 'transit.station',
                elementType: 'geometry',
                stylers: [{color: '#eeeeee'}]
            },
            {
                featureType: 'water',
                elementType: 'geometry',
                stylers: [{color: '#c9c9c9'}]
            },
            {
                featureType: 'water',
                elementType: 'geometry.fill',
                stylers: [{color: '#cad2d3'}]
            },
            {
                featureType: 'water',
                elementType: 'labels.text.fill',
                stylers: [{color: '#9e9e9e'}]
            }
        ]
    };

    location_map = new google.maps.Map(map_container, map_options);

    map_markers = {};

    locations_array.map(function (location, i) {
        let isNotQuebec = true;
        if (location.content.state == "Quebec" && window.location.href.indexOf('quebec') == -1) {
            isNotQuebec = false;
        }
        if(mapGlobalOptions.site_country_code.indexOf(location.content.country.toUpperCase()) > -1 && isNotQuebec) {
            location.content.isLocalClub = true;
        } else {
            location.content.isLocalClub = false;
        }

        let location_status = location.content.status;
        let location_position = {
            lat: parseFloat(location.latitude),
            lng: parseFloat(location.longitude)
        };
        map_marker_icon = setMarkerPins(location_status);
        let map_marker = new google.maps.Marker({
            active: false,
            content: location.content,
            icon: map_marker_icon,
            latitude: location.latitude,
            longitude: location.longitude,
            position: location_position,
            map: location_map
        });
        map_marker.addListener('mouseover', function () {
            let currentPin = this.content.number;
            jQuery('#location-finder-list-view .list-results li[data-club-id="'+currentPin+'"]').addClass('active');
            if (this.active === false) {
                map_marker_icon = setMarkerPins(this.content.status, 'hover');
                this.setIcon(map_marker_icon);
            }
        });
        map_marker.addListener('mouseout', function () {
            jQuery('#location-finder-list-view .list-results li').removeClass('active');
            if (this.active === false) {
                map_marker_icon = setMarkerPins(this.content.status);
                this.setIcon(map_marker_icon);
            }
        });
        map_marker.addListener('click', function () {
            if (map_marker_active) {
                map_marker_active.active = false;
                map_marker_icon = setMarkerPins(map_marker_active.content.status);
                map_marker_active.setIcon(map_marker_icon);
            }
            if (this.active === false) {
                map_marker_active = this;
                this.active = true;
                location_map.panTo(this.position);
                map_marker_icon = setMarkerPins(this.content.status, 'active');
                this.setIcon(map_marker_icon);
                if (mapGlobalOptions.show_map_card == true) {
                    openInfoWindow(this);
                } else {
                    if (!this.content.isLocalClub) {
                        getModal(this.content.number).show();
                    } else {
                        window.location.href = this.content.url;
                    }
                }
            }

            let location_content_distance;
            if (mapGlobalOptions.site_distance_units === 'miles') {
                location_content_distance = this.distance + ' ' + translations.miles;
            } else if (mapGlobalOptions.site_distance_units === 'kilometers') {
                location_content_distance = this.distance + ' ' + translations.kilometers;
            }
            dataLayer.push({
                'event': 'map',
                'address': this.content.address,
                'address2': this.content.address2,
                'afNumber': this.content.number,
                'city': this.content.city,
                'latitude': this.latitude,
                'longitude': this.longitude,
                'phoneNumber': this.content.phone,
                'postCode': this.content.zip,
                'post_title': this.content.title,
                'stateProvince': this.content.gym_state_abbr,
                'distance': location_content_distance
            });
        });

        map_markers['marker' + location.content.number] = map_marker;
    });

    location_map.addListener('bounds_changed', debounce(() => {
        let current_map_zoom = location_map.getZoom();
        if (current_map_zoom >= map_zoom_default || jQuery('.mobile-tab-map-view').hasClass('.active')) {
            // Attempt to adjust zoom before running buildLocationsArrayClosest which forces a map extend for the 10 closest locations, which can be a jarring change
            if (buildLocationsArray() === false) {
                location_map.setZoom(current_map_zoom - 1);
                if (buildLocationsArray() === false) {
                    location_map.setZoom(current_map_zoom - 2);
                    if (buildLocationsArray() === false) {
                        buildLocationsArrayClosest();
                    }
                }
            }
            window.history.pushState(JSON.stringify({location: location_map.getCenter()}), '');
        }
    }, 250));

    let map_markers_cluster_options = {
        averageCenter: true,
        maxZoom: map_zoom_max - 1,
        styles: [
            {
                height: 35,
                textColor: 'white',
                textSize: 12,
                url: mapGlobalOptions.themeAssets + 'map-cluster-m1' + (mapGlobalOptions.v2_map_markers ? '-v2' : '') + '.png',
                width: 35,
                textLineHeight: 35
            },
            {
                height: 45,
                textColor: 'white',
                textSize: 12,
                url: mapGlobalOptions.themeAssets + 'map-cluster-m2' + (mapGlobalOptions.v2_map_markers ? '-v2' : '') + '.png',
                width: 45,
                textLineHeight: 45
            },
            {
                height: 60,
                textColor: 'white',
                textSize: 12,
                url: mapGlobalOptions.themeAssets + 'map-cluster-m3' + (mapGlobalOptions.v2_map_markers ? '-v2' : '') + '.png',
                width: 60,
                textLineHeight: 60
            },
            {
                height: 75,
                textColor: 'white',
                textSize: 12,
                url: mapGlobalOptions.themeAssets + 'map-cluster-m4' + (mapGlobalOptions.v2_map_markers ? '-v2' : '') + '.png',
                width: 75,
                textLineHeight: 75
            }
        ]
    };

    map_markers_cluster = new MarkerClusterer(location_map, map_markers, map_markers_cluster_options);

    google.maps.event.addListener(map_markers_cluster, "mouseover", function (c) {
        c.clusterIcon_.div_.firstChild.src = setClusterIcons(c.clusterIcon_.style.height, 'hover');
    });

    google.maps.event.addListener(map_markers_cluster, "mouseout", function (c) {
        c.clusterIcon_.div_.firstChild.src = setClusterIcons(c.clusterIcon_.style.height);
    });
}

//throttle function, aka debounce
function debounce(fn, time) {
    let timeout;
    return function() {
        const args = arguments;
        const functionCall = () => fn.apply(this, args);
        clearTimeout(timeout);
        timeout = setTimeout(functionCall, time);
    }
}

function openInfoWindow(marker) {
    if (map_infowindow) {
        map_infowindow.close();
    }

    let location_content_status_text = '',
        location_content_address = '',
        location_content_format_address = '',
        location_content_phone;

    if (marker.content.is_temp_closed == "true") {
        location_content_status_text = ' (' + translations.temporarilyClosed + ')';
    } else {
        if (marker.content.status == 1) {
            location_content_status_text = ' ' + translations.comingSoon;
        } else if (marker.content.status == 2) {
            location_content_status_text = ' ' + translations.openingSoon;
        }
    }

    if (mapGlobalOptions.address_format) {
        jQuery.each(mapGlobalOptions.address_format, function () {
            if (this.country_select === marker.content.country) {
                location_content_format_address = marker.content.address2 !== null ?
                    this.format.replace('{{address}}', marker.content.address)
                        .replace('{{address2}}', marker.content.address2)
                        .replace('{{city}}', marker.content.city)
                        .replace('{{state}}', marker.content.state)
                        .replace('{{state_abbr}}', marker.content.state_abbr)
                        .replace('{{zip}}', marker.content.zip)
                        .replace('{{country_abbr}}', marker.content.country) :
                    this.format.replace('{{address}}', marker.content.address)
                        .replace('{{address2}}', '')
                        .replace('{{city}}', marker.content.city)
                        .replace('{{state}}', marker.content.state)
                        .replace('{{state_abbr}}', marker.content.state_abbr)
                        .replace('{{zip}}', marker.content.zip)
                        .replace('{{country_abbr}}', marker.content.country);
            }
        });
    }

    if (location_content_format_address) {
        location_content_address = location_content_format_address;
    } else {
        location_content_address = marker.content.address2 !== null ?
            marker.content.address + ' ' + marker.content.address2 + '<br>' + marker.content.city + ', ' + marker.content.state_abbr :
            marker.content.address + '<br>' + marker.content.city + ', ' + marker.content.state_abbr + ' ' + marker.content.zip;
    }

    location_content_phone = marker.content.phone !== null ? marker.content.phone : '';

    let clubMarkerLink = '';
    let infoWindowContent = '';

    let wrapper = '<div class="infowindow-content" data-club-id="' + marker.content.number + '">';
    let name = '\t<h3 class="name link-text"><a class="name-link" href="' + marker.content.url + '">' + marker.content.title + location_content_status_text + '</a></h3>';
    let addr = location_content_address ? ('\t<div class="address">' + location_content_address + '</div>') : '';
    let phone = '\t<div class="phone"><span class="icomoon-icon-phone" aria-hidden="true"></span>' + location_content_phone + '</div>';

    if (mapGlobalOptions.themeName == 'anytimefitness') {
        let clubMarker = new AFClub(AF.decodeClub(marker));
        clubMarkerLink = clubMarker.getVisitGymUrl();

        infoWindowContent =
            wrapper +
            name +
            addr +
            phone +
            '	<div class="links link-text">' +
            '		<a target="_blank" href="' + decodeURIComponent(marker.content.directions_url) + '">' + translations.getDirections + '</a> | ' +
            '		<a class="linkVisitGym" href="' + (marker.content.isLocalClub ? clubMarkerLink : '#') + '">' + (marker.content.isLocalClub ? translations.visitThisGym : translations.visitAnytimeFitnessCountry.replace('{country_name}', translations.countries[marker.content.country])) + '</a>' +
            '	</div>' +
            '</div>';
    } else {
        clubMarkerLink = marker.content.url;

        infoWindowContent =
            wrapper +
            name +
            addr +
            '	<div class="links">' +
            jQuery('[data-location-club-id="' + marker.content.number + '"] .result-footer').clone().html() +
            '   </div>' +
            '</div>';
    }

    map_infowindow = new google.maps.InfoWindow({
        content: infoWindowContent,
        marker: marker.content.number
    });

    if (!marker.content.isLocalClub) {
        jQuery('body').on('click', `.infowindow-content[data-club-id=${marker.content.number}] .linkVisitGym, .infowindow-content[data-club-id=${marker.content.number}] .name-link`, (e) => {
            e.preventDefault();
            getModal(marker.content.number).show();
        });
    }

    map_infowindow.open(location_map, marker);

    google.maps.event.addListener(map_infowindow, 'closeclick', function () {
        let map_marker_target = map_markers['marker' + map_infowindow.marker],
            map_marker_target_icon = setMarkerPins(map_marker_target.content.status);
        map_marker_target.active = false;
        map_marker_target.setIcon(map_marker_target_icon);
    });

}

function getModal(afNumber) {
    if (!modals[afNumber]) {
        modals[afNumber] = (new AFRedirectToClubSiteModal(afNumber));
    }
    return modals[afNumber]
}

function buildLocationsArray() {

    template_results = jQuery('#location-finder-list-view .list-results');
    template_results.html('');
    map_distance_units = mapGlobalOptions.site_distance_units;
    map_zoom = location_map.getZoom();
    map_locations = [];
    let map_center = location_map.getCenter(),
        map_center_lat = map_center.lat(),
        map_center_lng = map_center.lng();
    current_location = {latitude: map_center_lat,longitude: map_center_lng};

    if (location_map.getBounds() == 'undefined') {
        location_map.setCenter(map_center);
    }
    jQuery.each(map_markers, function () {
        if (location_map.getBounds().contains(this.getPosition())) {
            let marker_distance,
                marker_lat = this.latitude,
                marker_lng = this.longitude;
            if (map_distance_units === 'miles') {
                marker_distance = calculateMiles(map_center_lat, map_center_lng, marker_lat, marker_lng);
            }
            else if (map_distance_units === 'kilometers') {
                marker_distance = calculateKilometers(map_center_lat, map_center_lng, marker_lat, marker_lng);
            }

            if (marker_distance >= 0) {
                this.distance = marker_distance.toFixed(1);
                map_locations.push(this);
            }
        }

    });

    if (map_locations.length > 0) {
        if (map_locations.length < 20 || map_zoom >= map_zoom_max) {
            showSidebar();
        } else {
            hideSidebar();
        }

        search_results_found = true;

        map_locations.sort(function (a, b) {
            let a_distance = parseFloat(a.distance);
            let b_distance = parseFloat(b.distance);
            if (a_distance > b_distance) {
                return 1;
            }
            if (a_distance < b_distance) {
                return -1;
            }
            return 0;
        });
        buildResults(map_locations);

    } else {
        search_results_found = false;
    }
    updateResultCount(map_locations.length);

    return search_results_found;
}

function buildLocationsArrayClosest() {
    search_results_found = true;
    let map_center = location_map.getCenter(),
        map_center_lat = map_center.lat(),
        map_center_lng = map_center.lng(),
        map_bounds = new google.maps.LatLngBounds(),
        map_lat_lng;

    current_location = {latitude: map_center_lat,longitude: map_center_lng};
    template_results = jQuery('#location-finder-list-view .list-results');
    template_results.html('');
    map_distance_units = mapGlobalOptions.site_distance_units;
    let map_mobile_results = mapGlobalOptions.mobile_location_results_shown;
    map_locations = [];

    if (typeof map_mobile_results == 'undefined') {
        map_mobile_results = 10;
    }

    for (const location of locations_array) {
        const {latitude, longitude} = location;

        const marker_distance = map_distance_units === 'miles'
            ? calculateMiles(map_center_lat, map_center_lng, latitude, longitude)
            : calculateKilometers(map_center_lat, map_center_lng, latitude, longitude);

        location.distance = parseFloat(marker_distance.toFixed(1));
    }
    locations_array.sort((a, b) => a.distance > b.distance ? 1 : a.distance < b.distance ? -1 : 0);
    map_locations = locations_array.slice(0, map_mobile_results);
    updateResultCount(map_locations.length);
    buildResults(map_locations);

    map_bounds.extend(location_map.getCenter());
    jQuery(map_locations).each(function () {
        map_lat_lng = new google.maps.LatLng(this.latitude, this.longitude);
        map_bounds.extend(map_lat_lng);
    });

    location_map.fitBounds(map_bounds,0);
    showSidebar();
}

function calculateMiles(map_lat, map_lng, location_lat, location_lng) {
    return (
        Math.acos(
            Math.sin(map_lat * Math.PI / 180) *
            Math.sin(location_lat * Math.PI / 180) +
            Math.cos(map_lat * Math.PI / 180) *
            Math.cos(location_lat * Math.PI / 180) *
            Math.cos((map_lng - location_lng) * Math.PI / 180)
        ) * 180 / Math.PI
    ) * 60 * 1.1515;
}

function calculateKilometers(map_lat, map_lng, location_lat, location_lng) {
    Math.radians = function (degrees) {
        return degrees * Math.PI / 180;
    };
    return (
        6371 * Math.acos(
            Math.cos(Math.radians(map_lat)) *
            Math.cos(Math.radians(location_lat)) *
            Math.cos(Math.radians(location_lng) - Math.radians(map_lng)) +
            Math.sin(Math.radians(map_lat)) *
            Math.sin(Math.radians(location_lat))
        )
    );
}

function updateResultCount(count) {
    if (mapGlobalOptions.geolocation_link != '1' || !checkLocationPermissions()) {
        template_results_count = jQuery('#location-finder-list-view .results .results-text');
        let result_count_text = '', sr_result_count_text = '';
        let textPin = "fa fa-map-marker";

        if (mapGlobalOptions.themeName == 'anytimefitness') {
            textPin = "icomoon icomoon-icon-pinpoint-fill";
        }

        if (count > 0) {
            result_count_text = '<i class="' + textPin + '" aria-hidden="true"></i> ' + translations.resultsNearYou + ' (<span class="results-number">' + count + ' ' + (count === 1 ? translations.result : translations.results).replace(/ $/, '') + '</span>)';
            sr_result_count_text = count + ' ' + (count === 1 ? translations.a11y.location_search_results_found_singular : translations.a11y.location_search_results_found_plural).replace(/ $/, '');
        } else {
            result_count_text = translations.noResults + translations.found + ". " + translations.pleaseTryDifferent;
            sr_result_count_text = translations.noResults + translations.found + ". " + translations.pleaseTryDifferent;
        }
        template_results_count.html(result_count_text);
        sr_results_count.html(sr_result_count_text);
    }
}

function buildResults(results) {
    let resultsHtml = '',
        days = translations.daysOfTheWeek,
        today = (new Date().getDay()+6) % 7, //Adjusts for Mon-Sun schedule
        dayOfWeek = days[today];
    const dayMapping = [];
    dayMapping['monday'] = 0;
    dayMapping['tuesday'] = 1;
    dayMapping['wednesday'] = 2;
    dayMapping['thursday'] = 3;
    dayMapping['friday'] = 4;
    dayMapping['saturday'] = 5;
    dayMapping['sunday'] = 6;

    if(mapGlobalOptions.themeName == 'anytimefitness') {
        app.importClubs(results);
    }
    jQuery(results).each(function() {
        let gym_content_pass = '',
            location_address = this.content.address ?? '',
            location_address2 = this.content.address2 ?? '',
            location_city = this.content.city ?? '',
            location_country = this.content.country ?? '',
            location_state = this.content.state ?? '',
            location_state_abbr = this.content.state_abbr,
            location_zip = this.content.zip ?? '',
            location_phone = this.content.phone ?? '',
            location_phone_unformatted = this.content.phone ?? '',
            location_address_link = this.content.directions_url,
            location_differentiator = '',
            location_content_status_text = '',
            location_content_distance = this.distance,
            resultAddress = location_address2 ? location_address+' '+location_address2 : location_address,
            closeTime = "";

        if (mapGlobalOptions.site_distance_units === 'miles') {
            location_content_distance += ' ' + translations.miles;
        } else if (mapGlobalOptions.site_distance_units === 'kilometers') {
            location_content_distance += ' ' + translations.kilometers;
        }

        resultAddress += '<br />'+location_city+', '+location_state_abbr+' '+location_zip;
        jQuery.each(mapGlobalOptions.address_format, function(index, format) {
            if (format.country_select === location_country) {
                resultAddress = location_address2 !== null ?
                    format.format.replace('{{address}}', location_address)
                        .replace('{{address2}}', location_address2)
                        .replace('{{city}}', location_city)
                        .replace('{{state}}', location_state)
                        .replace('{{state_abbr}}', location_state_abbr)
                        .replace('{{zip}}', location_zip)
                        .replace('{{country_abbr}}', location_country) :
                    format.format.replace('{{address}}', location_address)
                        .replace('{{address2}}', '')
                        .replace('{{city}}', location_city)
                        .replace('{{state}}', location_state)
                        .replace('{{state_abbr}}', location_state_abbr)
                        .replace('{{zip}}', location_zip)
                        .replace('{{country_abbr}}', location_country);
            }
        });

        if (this.content.gmb != null && this.content.gmb != '') {
            location_address_link = this.content.gmb;
        }
        let addr = resultAddress ? resultAddress : '';
        if (!mapGlobalOptions.directions_link && resultAddress) {
            if (mapGlobalOptions.themeName == 'anytimefitness' && (jQuery.inArray("US", mapGlobalOptions.site_country_code) != -1 || jQuery.inArray("CA", mapGlobalOptions.site_country_code) != -1) ) {
                addr = '<span id="linksGetDirections-' + this.content.number + '" class="link-color">' + addr + '</span>';
            } else {
                addr = '<a id="linksGetDirections-' + this.content.number + '" class="link-color" target="_blank" href="' + decodeURIComponent(location_address_link) + '">' + addr + '</a>';
            }
        }

        if (location_phone !== null) {
            location_phone_unformatted = location_phone_unformatted.replace(/[ \-().]/g, '');
            addr += '<br /><a id="locationTelNumber-' + this.content.number + '" class="link-color" href="tel:' + location_phone_unformatted + '">' + location_phone + '</a>';
        }

        if (this.content.differentiator) {
            location_differentiator = ' ('+ this.content.differentiator +')';
        }

        if (this.content.status == 1) {
            location_content_status_text = ' ' + translations.comingSoon;
        } else if (this.content.status == 2) {
            location_content_status_text = ' ' + translations.openingSoon;
        }

        if (typeof this.content.hours != 'undefined' && this.content.hours.length > 0 && mapGlobalOptions.open_hours == true) {
            let todayCloseTime = 'Working Hours';
            // get info for hours operation expand
            let operation_hours = '',
                closed = true,
                showDayOfWeek = true;
            days.forEach((day) => {
                closed = true;
                showDayOfWeek = true;
                jQuery.each(this.content.hours, function(key, element) {
                    let dayTranslation = days[dayMapping[element['dayOfWeek']]];
                    if (dayTranslation == day && element['closed'] != true) {
                        //Format openTime
                        let tempOpenTime = element.openTime;
                        if (tempOpenTime != null && !tempOpenTime.includes(':')) {
                            let H = +tempOpenTime.substr(0, 2),
                                h = H % 12 || 12,
                                ampm = (H < 12 || H === 24) ? "am" : "pm";
                            tempOpenTime = h + ":" + tempOpenTime.substr(2, 2) + " " + ampm;
                        }
                        //Format closeTime
                        let tempCloseTime = element.closeTime;
                        if (tempCloseTime != null && !tempCloseTime.includes(':')) {
                            let H = +tempCloseTime.substr(0, 2),
                                h = H % 12 || 12,
                                ampm = (H < 12 || H === 24) ? "am" : "pm";
                            tempCloseTime = h + ":" + tempCloseTime.substr(2, 2) + " " + ampm;
                        }
                        operation_hours = operation_hours + '<li class="row"><div class="col-4">' + (showDayOfWeek ? (day.charAt(0).toUpperCase() + day.slice(1)) : '') + '</div><div class="col-8">' + tempOpenTime + ' - ' + tempCloseTime + '</div></li>';
                        closed = false;
                        showDayOfWeek = false;
                        if (element['dayOfWeek'] == dayOfWeek) {
                            todayCloseTime = tempCloseTime;
                        }
                    }
                });
                if (closed && mapGlobalOptions.themeName != 'anytimefitness') {
                    operation_hours = operation_hours + '<li class="row"><div class="col-4">' + (day.charAt(0).toUpperCase() + day.slice(1)) + '</div><div class="col-8">Closed</div></li>';
                }
            });

            if (mapGlobalOptions.themeName != 'anytimefitness' && (this.content.status == 2 || this.content.status == 4)) {
                let wtcStatuses = [];
                wtcStatuses['2'] = 'Opening Soon';
                wtcStatuses['4'] = 'Temporarily Closed';
                closeTime = '<div class="hoursOperation" style="padding: 0">' +
                    '<div class="row no-gutters">' +
                    '<div class="border-right border-light">' +
                    '<div class="hours-operation">' +
                    '<i class="icon-access_time" aria-hidden="true"></i>' +
                    wtcStatuses[this.content.status] +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '</div>';
            } else {
                closeTime = '<div class="hoursOperation" style="padding: 0">' +
                    '<div class="row no-gutters">' +
                    '<div class="border-right border-light">' +
                    '<div class="hours-operation">' +
                    '<a href="javascript:void(0);" class="hours-operation-toggle" aria-controls="hoursExpand-' + this.content.number + '"><i class="icon-access_time" aria-hidden="true"></i>'  +
                    (todayCloseTime == "Working Hours" ? todayCloseTime : translations.openHoursLabel + ' ' + todayCloseTime) +
                    ' <i class="icon-angle-down" aria-hidden="true"></i><span style="display:none"><ul class="hours-operation-expand">' + operation_hours + '</ul></span></a>' +
                    '</div>' +
                    '<ul class="hours-operation-expand" aria-expanded="false" id="hoursExpand-' + this.content.number + '">' +
                    operation_hours +
                    '</ul>' +
                    '</div>' +
                    '</div>' +
                    '</div>';
            }
        }

        let distanceDirectionsHtml = mapGlobalOptions.directions_link
            ? '<a href="' + location_address_link + '" target="_blank" class="directions">' + translations.directions + ' <i class="fa fa-external-link"></i></a><br />' +
            '    <span class="distance">' + location_content_distance + '</span>'
            : location_content_distance;
        let isNotQuebec = true;
        if (location_state == "Quebec" && window.location.href.indexOf('quebec') == -1) {
            isNotQuebec = false;
        }

        resultsHtml += '<li class="result" tabindex="0" data-redirect-to-club-site ' +
            'data-club-id="'+this.content.number+'" '+
            'data-distance="' + location_content_distance + '" ' +
            'data-location-club-id="'+this.content.number+'" '+
            'data-location-name="'+this.content.title+'" '+
            'data-location-address="'+location_address+'" '+
            'data-location-address2="'+location_address2+'" '+
            'data-location-city="'+location_city+'" '+
            'data-location-country="'+location_country+'" '+
            'data-location-state="'+location_state+'" '+
            'data-location-state-abbr="'+location_state_abbr+'" '+
            'data-location-zip="'+location_zip+'" '+
            'data-location-url="'+this.content.url+'" '+
            'data-location-gmb="'+this.content.gmb+'" '+
            'data-location-phone="'+location_phone+'" '+
            'data-location-booking="'+this.content.booking_url+'" '+
            'data-location-websiteurl="'+this.content.url+'" >' +
            '<div class="result-content">' +
            '    <h3 class="name link-text"><a href="' + ((jQuery.inArray(location_country, mapGlobalOptions.site_country_code) != -1 && isNotQuebec) ? this.content.url : '#' ) + '" data-result="' + this.content.number + '">' + this.content.title + location_differentiator + location_content_status_text + '</a>' +
            '    <span class="distance-directions link-text">' + distanceDirectionsHtml + '</span></h3>' +
            '    <span class="address">' + addr + '</span>' +
            closeTime +
            '</div>';

        let resultsFooterHtml = '';
        if(mapGlobalOptions.themeName == 'anytimefitness' &&
            ((this.content.status == 3 && this.content.pass_text.length && this.content.pass_url.length) ||
                (this.content.status == 3 && this.content.pass_length > 0) ||
                (this.content.status == 3 && parseFloat(mapGlobalOptions.force_club_7_day_passes) === 1))
        ) {
            let gym_content_pass_length = this.content.pass_length > 0 ? this.content.pass_length : mapGlobalOptions.default_pass_days,
                gym_content_pass_text = translations.nDayFreeTrial.replace(/%d/ig, gym_content_pass_length),
                gym_content_pass_url = this.content.pass_url ? this.content.pass_url : dynamicURLs.tryUsFreePage + '?club=' + this.content.number,
                button_cta_style = '',
                mobile_card = false;

            if (parseFloat(mapGlobalOptions.force_nday_pass_flow) === 1) {
                gym_content_pass_text = mapGlobalOptions.label_for_the_pass_link_on_find_a_gym_page.replace(/%d/ig, gym_content_pass_length);
            }

            if (jQuery(window).width() < 376 && (this.content.nat_camp_text.length + gym_content_pass_text.length) > 34) { // iPhone 6 or smaller
                mobile_card = true;
            } else if ((jQuery(window).width() > 767 && jQuery(window).width() < 1024) && (this.content.nat_camp_text.length + gym_content_pass_text.length) > 15) { // iPad, not iPad Pro
                mobile_card = true;
            }

            if(this.content.scheduling_enabled == "true" && this.content.is_temp_closed != "true" && mapGlobalOptions.show_reserve_link && mapGlobalOptions.reserve_gym_text != '') {
                resultsFooterHtml += '<div class="button-reserve"><a class="btn btn-sml btn-result" href="https://reserve.anytimefitness.com/clubs/'+this.content.number+'">'+mapGlobalOptions.reserve_gym_text+'</a></div>';
            }

            if (this.content.is_temp_closed != "true" && mapGlobalOptions.need_join_online_toggle &&  jQuery('#join-online-onoffswitch').is(':checked') && (typeof this.content.is_join_online !== 'undefined') && this.content.is_join_online) {
                gym_content_pass += '<a class="btn btn-sml btn-result join-online-link" href="' + this.content.join_online_url + '" style="padding: 0px 10px 5px 10px !important">' + translations.buttonJoinOnlineText + '</a><span class="divider">|</span> ';
            }
            if (this.content.isLocalClub) {
                if(this.content.is_temp_closed == "true" || this.content.no_7_day == "true") {
                    gym_content_pass += '<a class="btn btn-sml btn-result" href="' + this.content.url + '">' + translations.viewWebsite + '</a>';
                } else {
                    gym_content_pass += '<a class="btn btn-sml btn-result" href="' + gym_content_pass_url.replace(/https?:/, '') + '">' + gym_content_pass_text + '</a>';
                }
                if ((typeof this.content.is_nat_camp !== 'undefined') && this.content.is_nat_camp == true) {
                    if (mobile_card) {
                        button_cta_style = ' style="display: contents;"';
                        gym_content_pass += '<br>';
                    } else {
                        gym_content_pass += '<span class="divider"> | </span>';
                    }
                    gym_content_pass += '<a class="btn btn-sml btn-result" href="' + this.content.nat_camp_url + '">' + this.content.nat_camp_text + '</a>';
                }
                if (jQuery.inArray("ZA", mapGlobalOptions.site_country_code) != -1) {
                    if (mobile_card) {
                        button_cta_style = ' style="display: contents;"';
                        gym_content_pass += '<br>';
                    } else {
                        gym_content_pass += '<span class="divider"> | </span>';
                    }
                    gym_content_pass += '<a class="btn btn-sml btn-result" href="' + this.content.url + '">'  + translations.visitThisGym +  '</a>';
                }
            } else {
                gym_content_pass += '<a class="btn btn-sml btn-result get-direction" target="_blank" href="' + this.content.directions_url + '">' + translations.getDirections + '</a>';
                if (mobile_card) {
                    button_cta_style = ' style="display: contents;"';
                    gym_content_pass += '<br>';
                } else {
                    gym_content_pass += '<span class="divider"> | </span>';
                }
                gym_content_pass += '<a class="btn btn-sml btn-result" href="#">';
                gym_content_pass += translations.visitAnytimeFitnessCountry.replace('{country_name}', translations.countries[this.content.country]) + '</a>';
            }
            if (gym_content_pass.length > 0) {
                resultsFooterHtml += '<div class="button-cta"' + button_cta_style + '>' + gym_content_pass + '</div>';
            }
        } else {
            if(this.content.show_current_offer == "false" || mapGlobalOptions.show_current_offer != true ||
                typeof mapGlobalOptions.current_offer_text === 'undefined' || mapGlobalOptions.current_offer_text === '' ||
                typeof mapGlobalOptions.current_offer_link === 'undefined' || mapGlobalOptions.current_offer_link === ''
            ) {
                resultsFooterHtml += '	<a class="btn-white linkVisitLocation" href="' + this.content.url + '"><span>' + translations.visitThisGym + '</span></a>';
            } else {
                let offerLink = mapGlobalOptions.current_offer_link.replace('{location_number}', this.content.number);
                resultsFooterHtml += '	<a class="btn-white linkVisitLocation linkLocationSpecialOffer" href="' + offerLink + '"><span>' + mapGlobalOptions.current_offer_text + '</span></a>';
            }
            if(mapGlobalOptions.booking_button == true && this.content.status != 1 && this.content.booking_url.length != 0) {
                resultsFooterHtml += '	<a id="linkBookNow-' + this.content.number + '" target="_blank" class="btn-primary" href="' + this.content.booking_url + '">BOOK NOW</a>';
            }
        }

        if (this.content.status == 3 || (mapGlobalOptions.booking_button == true && this.content.status != 1)) {
            resultsHtml += '<div class="result-footer">' + resultsFooterHtml + '</div>';
        }
        resultsHtml += '</li>';
    });
    jQuery('#location-finder-list-view .list-results').html(resultsHtml);
    jQuery('#location-finder-search').find('.ajax-loader').removeClass('active');
    jQuery('#location-finder-search-button').find('i').show();
}

jQuery(document).ready(function(){
    jQuery(document).on('click', 'a.hours-operation-toggle', function(){
        let targetElem = jQuery(this).attr("aria-controls");
        if (jQuery(this).closest('.hoursOperation').hasClass('open')) {
            jQuery('#'+targetElem).attr("aria-expanded","false");
            jQuery(this).closest('.hoursOperation').removeClass('open');
        } else {
            jQuery('#'+targetElem).attr("aria-expanded","true");
            jQuery(this).closest('.hoursOperation').addClass('open');
        }
    });
});

function adjustMapSize(isTablet = false, hideMap = false) {
    if (jQuery('#location-finder-map').children().length > 0) {
        let map_center = location_map.getCenter(),
            winHeight = jQuery(window).height(),
            headerElement = jQuery('header.main'), // AF
            footerElement = jQuery('footer');
        if (headerElement.length == 0) {
            headerElement = jQuery('div[data-elementor-type="header"], header.site-header'); // WTC
            footerElement = jQuery('div[data-elementor-type="footer"]');
        }
        let heroHeight = jQuery('#hero-section').outerHeight() != undefined ? jQuery('#hero-section').outerHeight() : 0,
            headerHeight = jQuery(headerElement).outerHeight(),
            pageHeight = headerHeight + jQuery('main').first().outerHeight() + footerElement.outerHeight();
        if (isDesktop()) {
            document.getElementById("location-finder-map").style.removeProperty('display');
            document.getElementById("location-finder-list-view").style.removeProperty('display');
            let mapHeightNew = winHeight - heroHeight - headerHeight;
            if (mapHeightNew < (winHeight / 2)) {
                mapHeightNew = winHeight - headerHeight;
            }
            jQuery('#location-finder, #location-finder-map, #location-finder-sidebar').css('height', mapHeightNew);
            if (isTablet) {
                document.getElementById("location-finder").style.removeProperty('height');
                document.getElementById("location-finder-sidebar").style.removeProperty('height');
            }
            window.history.pushState(JSON.stringify({location:map_center}), '');
        } else {
            if (jQuery('.mobile-tab-list-view').hasClass('active')) {
                if (hideMap) {
                    jQuery('#location-finder-map').hide();
                }
                jQuery('#location-finder-list-view').show();
            } else if (jQuery('.mobile-tab-map-view').hasClass('active')) {
                jQuery('#location-finder-list-view').hide();
                jQuery('#location-finder-map').show();
            }
            let formHeight = jQuery('#location-finder').height(),
                mapHeightNew = 0;
            if (winHeight > jQuery(window).width()) { // Portrait map view
                mapHeightNew = winHeight - headerHeight - heroHeight - formHeight;
            } else { // Landscape map view
                if (jQuery('#sticky').length != 0) {
                    headerHeight = jQuery('#sticky').height();
                } else if (jQuery('header').length != 0) {
                    headerHeight = jQuery('header').height();
                }
                mapHeightNew = winHeight - headerHeight - jQuery('#location-finder').height();
            }
            if (winHeight < pageHeight) {
                if (mapHeightNew < 480) {
                    mapHeightNew = 480;
                }
                jQuery('#location-finder-map').css('height', mapHeightNew);
            }
            document.getElementById("location-finder-sidebar").style.removeProperty('height');
        }
        google.maps.event.trigger(location_map, "resize");
        location_map.setCenter(map_center);
    }
}

function changeDesktopHeader() {
    if (mapGlobalOptions.themeName != 'anytimefitness' && jQuery('#hero-section-h1').length) {
        if (isDesktop()) {
            if (jQuery('#hero-section-h1').attr("hero_header_desktop")) {
                jQuery('#hero-section-h1').text(jQuery('#hero-section-h1').attr("hero_header_desktop"));
            }
        } else {
            if (jQuery('#hero-section-h1').attr("hero_header_mobile")) {
                jQuery('#hero-section-h1').text(jQuery('#hero-section-h1').attr("hero_header_mobile"));
            }
        }
        jQuery("#hero-section-h1").show();
    }
}
function reCenterMap(center_lat, center_lng) {
    let search_location = {location:{
            lat: center_lat,
            lng: center_lng
        }};
    location_map.setZoom(map_zoom_max);
    location_map.setCenter(search_location.location);
    window.history.pushState(JSON.stringify(search_location), '');
}

function submitSearchCurrent() {
    let seb_geolocation = checkCookiePermissions();
    if (seb_geolocation) {
        if (seb_geolocation != 'blocked') {
            let seb_coords  = seb_geolocation.split(',');
            resetResults();
            reCenterMap(parseFloat(seb_coords[0]),parseFloat(seb_coords[1]));
            current_location = {latitude: parseFloat(seb_coords[0]), longitude: parseFloat(seb_coords[1])};
        } else {
            jQuery('#searchField').focus();
            if ( !isDesktop() ) {
                resetResults();
                reCenterMap(parseFloat(mapGlobalOptions.location_bias_center.lat),parseFloat(mapGlobalOptions.location_bias_center.lng));
                current_location = {latitude: parseFloat(mapGlobalOptions.location_bias_center.lat), longitude: parseFloat(mapGlobalOptions.location_bias_center.lng)};
            }
        }
    } else {
        if (checkLocationPermissions() && navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (position) {
                if (!position) {
                    jQuery('#searchField').focus();
                    return;
                }
                resetResults();
                reCenterMap(position.coords.latitude,position.coords.longitude);
                current_location = {latitude: position.coords.latitude, longitude: position.coords.longitude};
                setCookie('seb_geolocation', position.coords.latitude+','+position.coords.longitude);
            },function(){
                jQuery('#searchField').focus();
                if ( !isDesktop() ) {
                    resetResults();
                    reCenterMap(parseFloat(mapGlobalOptions.location_bias_center.lat),parseFloat(mapGlobalOptions.location_bias_center.lng));
                    current_location = {latitude: parseFloat(mapGlobalOptions.location_bias_center.lat), longitude: parseFloat(mapGlobalOptions.location_bias_center.lng)};
                }
                setCookie('seb_geolocation', 'blocked');
            });
        } else {
            console.log("Geolocation is blocked or not supported by this browser.");
            jQuery('#searchField').focus();
        }
    }
}

function submitSearchForm() {
    jQuery("#locationFinder").submit(function (event) {
        event.preventDefault();
        if ( jQuery('#searchField').val() ) {
            jQuery('#resultsText').empty();
            jQuery('#location-finder-search-button').find('i').hide();
            jQuery('#location-finder-search').find('.ajax-loader').addClass('active');
            // Snippet: Find a Club Search
            let delay = 1000;
            let attempt = 1;
            let timerId = setTimeout(function request() {
                if (jQuery(".location-finder-list-view .list-results li").length > 0 || attempt >= 5) {
                    if (typeof event.originalEvent === "undefined") {
                        let ga4_obj = {};
                        if (mapGlobalOptions.themeName == 'anytimefitness') {
                            ga4_obj = {
                                'event' : 'find_club_search',
                                'search_location': jQuery('#searchField').val(),
                                'search_results': (attempt >= 5 ? 0 : jQuery(".location-finder-list-view .list-results li").length)
                            };
                        } else { // WTC
                            ga4_obj = {
                                'event' : 'find_club_search',
                                'find_club_search' : {
                                    'location': jQuery('#searchField').val(),
                                    'results': (attempt >= 5 ? 0 : jQuery(".location-finder-list-view .list-results li.result").length),
                                    'nearest': (attempt >= 5 ? '' : jQuery(".location-finder-list-view .list-results li:first .result-content .name.link-text > a").text())
                                }
                            };
                        }
                        (window.dataLayer=window.dataLayer||[]).push(ga4_obj);
                    }
                } else {
                    attempt += 1;
                    timerId = setTimeout(request, delay);
                }
            }, delay);
            // end Snippet: Find a Club Search
        }

        let map_search_query = jQuery('#searchField').val();

        searchGeocode(map_search_query, 'address');
    });
}

function searchGeocode(searchValue, searchType) {
    if (searchType === 'latlng') {
        location_map.setCenter(searchValue.location);
        location_map.setZoom(map_zoom_max);

        jQuery('#resultsText').empty();
        jQuery('#location-finder-search-button').find('i').hide();
        jQuery('#location-finder-search').find('.ajax-loader').addClass('active');
    } else {
        if (searchValue.length > 0) {
            resetResults();
            let search_geocode = '',
                map_geocoder = new google.maps.Geocoder;

            if (searchType === 'address') {
                search_geocode = {'address': searchValue};
            } else if (searchType === 'placeId') {
                search_geocode = {'placeId': searchValue};
            }

            map_geocoder.geocode(search_geocode, function (results, status) {
                if (status == google.maps.GeocoderStatus.OK) {
                    let search_location = {search:searchValue,location:results[0].geometry.location};
                    location_map.setZoom(map_zoom_max);
                    if (searchValue == "Clodine, TX 77469, USA") { // small google search inconsistency for zip code 77469. let's fix it on our end
                        location_map.setCenter({lat:parseFloat(29.5044684),lng:parseFloat(-95.70892409999999)});
                    } else {
                        location_map.setCenter(results[0].geometry.location);
                    }
                    window.history.pushState(JSON.stringify(search_location), '');
                } else {
                    jQuery('#searchField').focus();
                    showNoResultsError();
                }
                if (jQuery('#acResultsList').length) {jQuery('#acResultsList').hide();}
            });

        } else {
            jQuery('#searchField').focus();
            jQuery('#locationFinder').find('.error-msg.error-required').addClass('active');
        }
    }
}

jQuery("#location-finder-sidebar").on('scroll', function(){
    jQuery('#acResultsList').hide();
});

function showNoResultsError() {
    jQuery('#location-finder-search').find('.ajax-loader').removeClass('active');
    jQuery('#location-finder-search-button').find('i').show();
    jQuery('#locationFinder').find('.error-msg.error-empty').addClass('active');
}

function showSidebar() {
    map_container = jQuery('#location-finder');
    if (!map_container.hasClass('active')) {
        map_container.addClass('active');
    }
}

function hideSidebar() {
    map_container = jQuery('#location-finder');
    if (map_container.hasClass('active') && isDesktop()) {
        map_container.removeClass('active');
    }
}

function resetResults() {
    search_results_found = null;
}

function resultsInteractions() {
    let map_marker_target,
        map_marker_target_icon;

    template_results = jQuery('#location-finder-list-view .list-results');

    if (isDesktop()) {
        jQuery(template_results).on('mouseover', 'li.result', function () {
            jQuery(this).addClass('active');
            map_marker_target = map_markers['marker' + jQuery(this).data('clubId')];
            map_marker_target_icon = setMarkerPins(map_marker_target.content.status, 'hover');
            map_marker_target.setIcon(map_marker_target_icon);
        });

        jQuery(template_results).on('mouseout', 'li.result', function () {
            jQuery(this).removeClass('active');
            map_marker_target = map_markers['marker' + jQuery(this).data('clubId')];
            map_marker_target_icon = setMarkerPins(map_marker_target.content.status);
            map_marker_target.setIcon(map_marker_target_icon);
        });
    }

    jQuery('#location-finder-list-view .results .results-text').on('click keypress', 'a.geolocation-search', function(e) {
        e.preventDefault();
        jQuery('#searchField').val('');
        submitSearchCurrent();
    });
    jQuery("#location-finder-search-button").click(function () { locationSearchButtonClick() });

    jQuery(template_results).on('click keypress', 'li.result', function (e) {
        if ((!jQuery(e.target).is('a') && !jQuery(e.target).parent().is('a')) || jQuery(e.target).attr('href') == '#') {
            let isNotQuebec = true;
            if (jQuery(this).data('location-state') == "Quebec" && window.location.href.indexOf('quebec') == -1) {
                isNotQuebec = false;
            }
            if(jQuery.inArray(jQuery(this).data('location-country'), mapGlobalOptions.site_country_code) != -1 && isNotQuebec) {
                window.stop();
                let search_object = (typeof window.history.state == 'string') ? JSON.parse(window.history.state) : window.history.state;
                window.history.replaceState(JSON.stringify({search:search_object.search,location:search_object.location,result:jQuery(this).data('club-id').toString()}), '');
                jQuery('a[data-result]', this).click(function() {
                    this.click();
                    jQuery('body').append('<div class="ekko-lightbox modal"><div class="loader custom"><div class="runner"></div></div></div><div class="modal-backdrop show"></div>');
                }).click();
            } else {
                getModal(jQuery(this).data('club-id')).show();
            }
        }
    });
}

function setMarkerPins(locationStatus, pinState) {
    let pinUrl = mapGlobalOptions.themeAssets + 'map-pin';
    if (locationStatus == 3) {
        if (pinState === 'hover' || pinState === 'active') {
            pinUrl += '-active';
        }
    } else {
        pinUrl += '-grey';
        if (pinState === 'hover' || pinState === 'active') {
            pinUrl += '-hover';
        }
    }
    if (mapGlobalOptions.v2_map_markers == 1) {
        pinUrl += '-v2';
    }
    pinUrl += '.png';
    return {
        scaledSize: new google.maps.Size(35, 56),
        url: pinUrl
    };
}

function setClusterIcons(cluster, state) {
    let clusterIcon = mapGlobalOptions.themeAssets + 'map-cluster-';
    if (cluster === 35) {
        clusterIcon += 'm1';
    } else if (cluster === 45) {
        clusterIcon += 'm2';
    } else if (cluster === 60) {
        clusterIcon += 'm3';
    } else if (cluster === 75) {
        clusterIcon += 'm4';
    }
    if (state === 'hover') {
        clusterIcon += '-hover';
    }
    if (mapGlobalOptions.v2_map_markers == 1) {
        clusterIcon += '-v2';
    }
    clusterIcon += '.png';
    return clusterIcon;
}

function preloadHoverImages(images) {
    jQuery(images).each(function () {
        jQuery('<img/>')[0].src = this;
    });
}

function isDesktop() {
    if (jQuery(window).width() > 767) {
        return true;
    } else {
        return false;
    }
}

function prevResult() {
    let prevLocation = window.history.state ?? {};
    if (typeof prevLocation == 'string') {
        prevLocation = JSON.parse(window.history.state);
    }
    if (prevLocation.result != undefined) {
        // weirdness with iOS + back buttons
        jQuery('.ekko-lightbox.modal, .modal-backdrop.show').remove();

        jQuery("li.result[data-club-id='"+prevLocation.result+"']", this).addClass('active');
        delete prevLocation.result;
    }
}

function loadMap() {
    jQuery(function ($) {
        let prevLocation = window.history.state ?? {};
        if (typeof prevLocation == 'string') {
            prevLocation = JSON.parse(window.history.state);
        }

        jQuery('body').addClass('find-location');

        locations_array_full = (function () {
            let json = null,
                json_url = document.location.origin + appOptions.map.jsonPath;
            $.ajax({
                'async': false,
                'global': false,
                'url': json_url,
                'dataType': "json"
            }).done(function(data) {
                json = data;
            });
            return json;
        })();

        initMap();

        jQuery('.mobile-tabs .mobile-tab').click(function () {
            jQuery('.mobile-tabs .mobile-tab.active').removeClass('active');
            jQuery(this).addClass('active');
            if (jQuery('.mobile-tabs .mobile-tab-list-view').hasClass('active')) {
                jQuery('#location-finder-map').hide();
                jQuery('#location-finder-list-view').show();
            } else if (jQuery('.mobile-tabs .mobile-tab-map-view').hasClass('active')) {
                jQuery('#location-finder-list-view').hide();
                jQuery('#location-finder-map').show();
                if (typeof current_location == 'undefined') {
                    jQuery("#locationFinder").submit();
                    reCenterMap(current_location.latitude,current_location.longitude);
                }
                if(location_map.getZoom() < 4) {
                    reCenterMap(current_location.latitude,current_location.longitude);
                    adjustMapSize();
                }
                if(jQuery('#searchField').val() == '') {
                    adjustMapSize();
                }
            }
        });

        let search_load = decodeURIComponent(getCookie('location_search', '')), lat_load = getCookie('location_lat'), lng_load = getCookie('location_lng');
        eraseCookie('location_lat');
        eraseCookie('location_lng');
        eraseCookie('location_search');
        if (lat_load && lng_load) {
            let latLngArray = [];
            latLngArray.location = {lat:parseFloat(lat_load),lng:parseFloat(lng_load)};
            window.history.pushState(JSON.stringify(latLngArray), '');
            jQuery('#searchField').val(search_load);
            jQuery('#resultsText').empty();
            jQuery('#location-finder-search-button').find('i').hide();
            jQuery('#location-finder-search').find('.ajax-loader').addClass('active');
            searchGeocode(latLngArray, 'latlng');
        } else if (search_load) {
            jQuery('#searchField').val(search_load);
            jQuery('#resultsText').empty();
            jQuery('#location-finder-search-button').find('i').hide();
            jQuery('#location-finder-search').find('.ajax-loader').addClass('active');
            searchGeocode(search_load, 'address');
        } else {
            if (Object.keys(prevLocation).length !== 0) {
                jQuery('#searchField').val(prevLocation.search ?? '');
                jQuery('#resultsText .results-number').empty();
                jQuery('#location-finder-search-button').find('i').hide();
                jQuery('#location-finder-search').find('.ajax-loader').addClass('active');
                searchGeocode(prevLocation, 'latlng');
            } else {
                submitSearchCurrent();
            }
        }

        submitSearchForm();

        resultsInteractions();

        jQuery("#location-finder-list-view .list-results").bind("DOMNodeInserted", function() {
            prevResult();
        });

        if (mapGlobalOptions.geolocation_link == '1' && checkLocationPermissions()) {
            jQuery('#location-finder-list-view .results .results-text').html('<a href="#" class="geolocation-search"><i class="fa fa-crosshairs" aria-hidden="true"></i> ' + translations.geolocationText + '</a>');
        }

        preloadHoverImages([
            mapGlobalOptions.themeAssets + 'map-pin-active' + (mapGlobalOptions.v2_map_markers ? '-v2' : '') + '.png',
            mapGlobalOptions.themeAssets + 'map-pin-grey-hover' + (mapGlobalOptions.v2_map_markers ? '-v2' : '') + '.png',
            mapGlobalOptions.themeAssets + 'map-cluster-m1-hover' + (mapGlobalOptions.v2_map_markers ? '-v2' : '') + '.png',
            mapGlobalOptions.themeAssets + 'map-cluster-m2-hover' + (mapGlobalOptions.v2_map_markers ? '-v2' : '') + '.png',
            mapGlobalOptions.themeAssets + 'map-cluster-m3-hover' + (mapGlobalOptions.v2_map_markers ? '-v2' : '') + '.png',
            mapGlobalOptions.themeAssets + 'map-cluster-m4-hover' + (mapGlobalOptions.v2_map_markers ? '-v2' : '') + '.png'
        ]);
    });
}

jQuery(document).ready(function () {
    if(document.getElementById("location-finder-map") != null ) {
        hideSidebar();
        loadMap();
    }
    changeDesktopHeader();
});

jQuery(window).on("load", function () {
    adjustMapSize(false, true);
    jQuery('#location-finder-search').find('.ajax-loader').removeClass('active');
    jQuery('#location-finder-search-button').find('i').show();
    if (!isDesktop()) {
        jQuery('#location-finder-map').css('visibility', 'visible');
        jQuery('#location-finder-map').hide();
    }
});

jQuery(window).resize(function () {
    if ( !isDesktop() ) {
        if (jQuery('.mobile-tab-list-view').length == 0 || (jQuery('.mobile-tab-list-view').length && jQuery('.mobile-tab-list-view').hasClass('active'))) {
            setTimeout(() => {
                jQuery('#location-finder-map').hide();
            }, 1000);
        }
    }
    adjustMapSize();
    changeDesktopHeader();
});

jQuery(window).on("orientationchange", function () {
    adjustMapSize(true);
});

window.onpageshow = function(event) {
    if (event.persisted) {
        prevResult();
    }
};